import { RestError } from '@azure/core-http';
import { EditModuleDto, ModuleDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useApi } from '../../core/api/api.context';
import { QueryKeys } from '../../core/queries/query-keys.constants';

export function useQueryGetModule(moduleID?: string) {
  const api = useApi();

  return useQuery<ModuleDto | undefined, RestError>(
    [QueryKeys.MODULES, moduleID],
    async () => {
      if (!moduleID) return undefined;
      return await api.modulesController.get(moduleID);
    },
    { enabled: !!moduleID }
  );
}

export function useMutationUpdateModule() {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<ModuleDto, RestError, { moduleID: string; dto: EditModuleDto }>(
    async ({ moduleID, dto }) => {
      return await api.modulesController.edit(moduleID, dto);
    },
    {
      onSettled() {
        queryClient.invalidateQueries([QueryKeys.MODULES]);
        queryClient.invalidateQueries(QueryKeys.SETTINGS);
        queryClient.invalidateQueries([QueryKeys.HUBS_DETAILS]);
      }
    }
  );
}
